export default "__VITE_ASSET__DhE1Sei3__"